<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 10:21:22
 * @最后编辑: Betway
 * @最后修改时间: 2022-01-10 16:44:00
-->
<template>
  <mrc_ess_skeleton_loader
    :loading="$store.state.uuid ? skeletonloading : false"
  >
    <v-card>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_Template_name') + '*'"
              :isNational="judegNational('template_name')"
              :readonly="disabled"
              :error-messages="
                $errors(
                  'list',
                  'template_name',
                  requiredRule.concat(nocharacter)
                )
              "
              v-model="list.template_name"
            >
            </mrc_ess_multiText>
          </v-col>

          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_Short_code') + '*'"
              :error-messages="
                $errors(
                  'list',
                  'template_code',
                  requiredRule.concat(nocharacter)
                )
              "
              :isNational="judegNational('template_code')"
              :readonly="disabled"
              v-model="list.template_code"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_multiText
              :label="$t('label_template_Url')"
              :isNational="judegNational('url')"
              :readonly="disabled"
              v-model="list.url"
            >
            </mrc_ess_multiText>
          </v-col>
          <v-col cols="12" sm="6">
            <mrc_ess_NumInput
              :readonly="disabled"
              :maxlength="8"
              :valueLength="false"
              :label="$t('label_template_ttl')"
              v-model="list.ttl"
            ></mrc_ess_NumInput>
          </v-col>
          <v-col cols="12" sm="12">
            <mrc_ess_multiText
              textarea
              noRequired
              :isNational="false"
              :placeholder="$t('label_template_Data')"
              :readonly="disabled"
              v-model="list.data"
              :label="$t('label_template_Data')"
            ></mrc_ess_multiText>
          </v-col>
          <v-col cols="12">
            <mrc_ess_multiText
              :label="$t('label_describe') + '*'"
              :error-messages="
                $errors(
                  'list',
                  'template_description',
                  requiredRule.concat(nocharacter)
                )
              "
              :isNational="judegNational('template_description')"
              :readonly="disabled"
              v-model="list.template_description"
            >
            </mrc_ess_multiText>
          </v-col>
        </v-row>
      </v-card-text>
      <template v-if="$store.state.uuid">
        <mrc_ess_submitBtn
          @cancel="cancel"
          :loading="loading"
          @success="success"
          v-if="!disabled"
        ></mrc_ess_submitBtn>
      </template>
      <template v-else>
        <mrc_ess_submitBtn
          @cancel="addcancel"
          @success="addsuccess"
          :successText="$t('label_The_next_step')"
          v-if="!disabled"
        ></mrc_ess_submitBtn>
      </template>
    </v-card>
  </mrc_ess_skeleton_loader>
</template>

<script>
import {
  getMessageTemplateDetail,
  updateMessageTemplateDetail,
} from "@/service/api/pushMessageTemplate";
import {
  required,
  maxLength,
  between,
  email,
  url,
} from "vuelidate/lib/validators";
export default {
  components: {},
  props: {
    disabled: {
      type: Boolean,
    },
  },
  data() {
    return {
      skeletonloading: true,
      list: {
        ttl: 0,
      },
      loading: false,
    };
  },
  computed: {},
  created() {},
  watch: {},
  async mounted() {
    this.national("mrbase_sys_message_push_template");
    if (this.$store.state.uuid) {
      await this.getdetail();
    } else {
    }
  },

  methods: {
    getData(val) {
      this.$set(this.list, "function_uuid", "");
    },
    async getdetail() {
      this.skeletonloading = true;
      const res = await getMessageTemplateDetail({
        uuid: this.$store.state.uuid,
      });
      if (res.code == 200) {
        // this.$store.commit('set_subPage_name', res.data.template_name)
        this.list = res.data;
        this.skeletonloading = false;
      }
    },
    async cancel() {
      await this.getdetail();
      this.$emit("changeReadonly");
    },
    async success() {
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      this.loading = true;
      await updateMessageTemplateDetail(
        this.$deletefield(null, this.list)
      ).then((res) => {
        if (res.code == 200) {
          this.getdetail();
          this.$emit("changeReadonly");
          this.$emit("changeFunctionUuid");
          this.$Message({
            text: this.$t("message_The_operation_was_successful"),
          });
        }
      });
      this.loading = false;
    },
    addcancel() {
      this.$myConfirm({
        content: this.$t("message_Confirm_the_cancellation_of_the_edit"),
      })
        .then((res) => {
          this.$router.push({
            name: "pushMessageTemplate",
          });
        })
        .catch((err) => {});
    },
    addsuccess() {
      // console.log(this.list);
      this.$v.list.$touch();
      if (this.$v.list.$error) return;
      this.$emit("changee1", 2, this.list);
    },
  },
  validations: {
    list: {
      template_name: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      template_code: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      template_description: {
        required,
        nocharacter(value) {
          return this.$myVerify.nocharacter(this.INT(value));
        },
      },
      // systemRequired (value) {
      //   if (this.$store.state.userData.userType == 4) {
      //     return value
      //   }
      //   else {

      //   }
      // }
      // isshow: {

      // },
    },
  },
};
</script>

